import incptCoin from '../../assets/brand/incpt-coin.png';

type Props = {
  /** Layout box, matching the on-chain coin icons in the same row. */
  size?: number;
  /**
   * How much of that box the mark itself takes. The artwork carries its own
   * transparent padding, so next to the full-bleed circular coin marks it
   * reads a size smaller; >1 lets it overflow the box and match them
   * optically without changing the row's geometry.
   */
  scale?: number;
  className?: string;
};

/**
 * INCPT mark, matching the `Icon` signature of the on-chain coins so it drops
 * into the same asset rows. The artwork is the prototype's own logo, so the
 * coin reads identically in both apps.
 */
export function IncptIcon({ size = 44, scale = 1, className }: Props) {
  const mark = size * scale;
  return (
    <span
      className={`relative flex shrink-0 items-center justify-center ${className ?? ''}`}
      style={{ width: size, height: size }}
    >
      <img
        src={incptCoin}
        alt=""
        className="max-w-none object-contain"
        style={{ width: mark, height: mark }}
      />
    </span>
  );
}
